import { createSelector } from 'reselect';
import { selectors as dequeSelectors } from '@saucelabs/sl-module-deque';

export const accessibilitySelector = (store) => store.apps.job.files;

export const loadAccessibilityData = createSelector([
  accessibilitySelector,
  dequeSelectors.isIntegrationEnabled,
],
(filteredState, isDequeEnabled) => ({
  loadingStatus: filteredState.get('status'),
  files: filteredState.get('files'),
  isDequeEnabled,
}));
